import InputConfig from '../../Components/InputConfig';
import { SPLIT_DOC_PARAMETERS } from '../../core/constants';
import DeleteIcon from '@mui/icons-material/Delete';
import useCommonStyles from '../../commonStyles';

//mui imports====
import { Grid } from '@mui/material';
import { Box } from '@mui/system';

//===============

const { KEY, SPLIT } = SPLIT_DOC_PARAMETERS;

const SplitCard = ({ splitData, index, updateSplitObj, deleteSplitObj }) => {
	const commonStyleClasses = useCommonStyles();
	return (
		<Grid item xs={6}>
			<Box
				style={{
					border: '1px solid rgba(0, 0, 0, 0.38)',
					padding: '2rem',
					margin: '.4rem',
					borderRadius: '4px'
				}}
			>
				<Grid container rowGap={3}>
					<Grid item xs={12}>
						<InputConfig
							isObjectEditor={false}
							editable={false}
							label="Script Name"
							directValue={splitData[KEY]}
							updateDirectValue={() => {}}
							inputStyles={{ width: '100%' }}
							labelStyles={{ width: '100%' }}
						/>
					</Grid>
					<Grid item xs={12}>
						<InputConfig
							isObjectEditor={false}
							inputType="number"
							label="Split Percentage"
							directValue={splitData[SPLIT]}
							updateDirectValue={(val) => {
								const updatedSplitData = { ...splitData, [SPLIT]: val };
								updateSplitObj(index, updatedSplitData);
							}}
							isMandatory={true}
							inputStyles={{ width: '100%' }}
							labelStyles={{ width: '100%' }}
						/>
					</Grid>
					<Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<DeleteIcon
							color="primary"
							onClick={() => deleteSplitObj(index)}
							className={commonStyleClasses.icon}
						/>
					</Grid>
				</Grid>
			</Box>
		</Grid>
	);
};

export default SplitCard;
